import React from 'react';

import PropTypes from 'prop-types';

import { useDevice } from '@bonnet/next/device';

import { Carousel, ResponsiveImage } from 'reaxl';
import { EmailCTA } from 'reaxl-email';

function MediaSliderPlaceholder({
    emailCTAProps,
    listingTitle = 'Listing',
}) {
    const device = useDevice();
    const isMobileOrTablet = device.lessThan.md;

    const fallbackImg = '/cm-api/content/static/img/placeholders/vin_placeholder.png';

    // Render request button
    const renderRequestButton = () => (
        <EmailCTA
            {...emailCTAProps}
            className="slider-button img-rounded placeholder-request-button"
            key="requestButton"
            showIcon={false}
            buttonStyle="link"
            context="mediaGallery"
            labelKey="requestPhotos"
        />
    );

    // Render placeholder image
    const renderImgPlaceholder = () => (
        <div
            className="position-relative"
            key="ImgPlaceholder"
        >
            <ResponsiveImage
                alt={`${listingTitle} image placeholder`}
                src={fallbackImg}
                lazyload={false}
                draggable={false}
            />
            <div className="placeholder-box-shadow img-rounded" />
        </div>
    );

    // Xs and Sm Slider layout
    if (isMobileOrTablet) {
        return (
            <div
                data-cmp="MediaSliderPlaceholder"
                className="padding-horizontal-2"
            >
                {renderRequestButton()}
            </div>
        );
    }

    return (
        <Carousel data-cmp="mediaSliderPlaceholder">
            <div
                key="Placeholder-Request-Button"
            >
                {renderRequestButton()}
            </div>
            {/* Spacer div to ensure media-slider-column is the 3rd child, matching MediaSlider structure */}
            <div key="Placeholder-Spacer" />
            <div
                key="Placeholder-Column"
                className="media-slider-column"
            >
                <div
                    key="placeholder-1"
                    className="padding-1"
                >
                    {renderImgPlaceholder()}
                </div>
                <div
                    key="placeholder-2"
                    className="padding-1"
                >
                    {renderImgPlaceholder()}
                </div>
            </div>
        </Carousel>
    );
}

MediaSliderPlaceholder.propTypes = {
    emailCTAProps: PropTypes.object,
    listingTitle: PropTypes.string,
};

export default React.memo(MediaSliderPlaceholder);
